export default {
  isOpen: false,
  open() {
    this.isOpen = true
    this.updateBody()
  },
  close() {
    this.isOpen = false
    this.updateBody()
  },
  toggle() {
    this.isOpen = !this.isOpen
    this.updateBody()
  },
  updateBody() {
    if (this.isOpen === true) {
      document.body.classList.remove('overflow-y-scroll')
      document.body.classList.add('overflow-hidden')
    } else {
      document.body.classList.remove('overflow-hidden')
      document.body.classList.add('overflow-y-scroll')
    }
  }
}
